import React from "react";
import "./CoreValues.css";
export default function CoreValues() {
  const values = [
    { icon: "🛡️", title: "Integrity", subtitle: "Ethical Conduct" },
    { icon: "💡", title: "Innovation", subtitle: "Ideas & Creativity" },
    { icon: "🤝", title: "Teamwork", subtitle: "Cooperation & Coordination" },
    { icon: "⭐", title: "Customer", subtitle: "Satisfaction" },
  ];

  return (
    <section className="core-values">
      <h2>Guiding Principles: Our Core Values</h2>

      <div className="value-grid">
        {values.map((val, index) => (
          <div className="value-card" key={index}>
            <div className="value-icon">{val.icon}</div>
            <h3>{val.title}</h3>
            <p>{val.subtitle}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
